// disable no-invalid-getInitialProps
import Calculator from '@comp/Calculator/Calculator';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const Cal = ({ isScientific }) => <Calculator isScientific={isScientific} />;

Cal.pageInfo = {
  name: 'Calculator',
  isMWebSupported: true,
  layoutOptions: {
    hideIntercom: true,
    hideFreshbot: true
  }
};

Cal.Layout = ({ children }) => children;

Cal.getInitialProps = async ({ query }) => {
  return { isScientific: query.scientific === 'true' };
};

export default Cal;
Cal.Wrapper = PageReduxProvider;
